import { render, staticRenderFns } from "./Wp_grid.vue?vue&type=template&id=5c1630ea&scoped=true&"
import script from "./Wp_grid.vue?vue&type=script&lang=js&"
export * from "./Wp_grid.vue?vue&type=script&lang=js&"
import style0 from "./Wp_grid.vue?vue&type=style&index=0&id=5c1630ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1630ea",
  null
  
)

export default component.exports